import $ from "jquery";
import is from "is_js";

window.jQuery = $
window.$ = $
window.is = is

require("./jquery.fancybox.js");
require("./sliders.js");


document.addEventListener("DOMContentLoaded", function(){
	if(!window.App)
		contentLoaded();
});

window.contentLoaded = () => {
	// select
	$("body").on("mousedown", "main select:not(.no-my-select)", function(e){
		const $this = $(this);
	
		if (is.touchDevice()) return;
	
		e.preventDefault();

		if (this.MySelect){

			if (this.MySelect.el.classList.contains("js__opened")){

				this.MySelect.close();

				this.MySelect.destroy();
				return;
			}

			this.MySelect.destroy();
		}
		
		const select = window.selectInitial(this);
	
		this.classList.add("my-select");
		this.closest("div").style.position = "relative";

	});

	// fancybox
	$(".fancybox").fancybox({
		trapFocus: false,
		touch: false,
		buttons: ["fullscreen", "close", "thumbs"],
		image: {
			preload: true,
		},
		transitionEffect: "slide",
	});

	// mobile-menu
	$('.burger').click(function(){
		$('body').toggleClass('js__menu--open');
	});

	// catalog-categories
	$('.catalog__categories-items').each(function(){
		$(this).find('.all-cats').click(function(){
			$(this).parent('.catalog__categories-items').toggleClass('js__open');
		});
	});

	// ordering-personal
	if(document.querySelector('.btn-edit')){

		document.querySelectorAll('.btn-edit').forEach(btn => btn.addEventListener('click', function(){

			let input = btn.previousElementSibling;

			if(input.getAttribute('readonly')) {
				input.removeAttribute('readonly');
				input.classList.add('active');
			} else {
				input.setAttribute('readonly', 'readonly');
				input.classList.remove('active');
			}

		}))
	}

	// order-card
	$('.order-card').each(function(){
		$(this).find('.order-card__head').click(function(){
			$(this).toggleClass('open');
			$(this).siblings('.order-card__body').slideToggle();
		});
	});

	// copy-promocode
	$('.promocode__btn').click(function(){
		var copyText = $(this).siblings(".promocode__input");
		copyText.select();
		document.execCommand("copy");
		$(this).siblings('.promocode__text').css('opacity', '1');
	});

	// header-search
	$('.search-btn').on('click', function() {
		$('.header-search').toggleClass('js__open');
	});

	$('.header-search__close').on('click', function() {
		$('.header-search').removeClass('js__open');
	});

	// cart-preview
	// $('.header .cart-btn').on('click', function(e){
	// 	e.preventDefault();
	// 	$('.cart-preview').addClass('active');
	// });

	// $('.cart-preview__close').click(function(){
	// 	$('.cart-preview').removeClass('active');
	// });

	// $("body").click(function (e) {
	// 	if (!$(e.target).is($('.cart-preview')) && !$(e.target).is($('.header .cart-btn')) && !$('.header .cart-btn').has(e.target).length && !$('.cart-preview').has(e.target).length) {
	// 		$('.cart-preview').removeClass('active');
	// 	}
	// });


	// slidersInit
	window.productsSlidersInit();
	window.actionsSlidersInit();
	window.productCardSlidersInit();

}
